/**************************************************
 * Nombre:       Seccion_Documentos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Usuario from "../Dialogos/Dialogo_Usuario";
import {theme} from "../../Tema";
import Tarjeta_Documentos from "../Tarjetas/Tarjeta_Documentos";
import {where} from "firebase/firestore";
import {usuarioContext} from "../../App";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";


const Seccion_Documentos = () => {
    const cData = useContext(usuarioContext)
    const {sCell} = useResponsive()
    const [pdfs, setPdfs] = useState([]);
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Usuario,
        titulo: 'Detalles del usuario',
       // realizado: cargarNuevamente
    })



    useEffect(() => {

        let usuario = cData.usuario;

        if (usuario && usuario.pais) {
            let w = [where('paises', 'array-contains-any', [usuario.pais, 'Todos'])]
            obtenerColWheres({col: 'pdfs', wheres: w}).then((dox) => {
                setPdfs(dox.data)
            })
        }


    }, [cData])

    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px', pb: 6}}
                spacing={0}
            >

                <Dialogo/>

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{
                                        color: theme.palette.primary.main,
                                        fontSize: sCell ? 32 : 36,
                                        fontWeight: 800,
                                        lineHeight: 1.1
                                    }}>
                                        Documentos PDF de apoyo
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 9}} sx={{justifyContent: 'flex-start', mt: sCell ? 1.5 : 0}}>
                                    <Typography sx={{fontSize: 14, fontWeight: 400}}>
                                        Descarga los materiales complementarios en PDF y refuerza cada aprendizaje con
                                        recursos prácticos y claros.
                                    </Typography>
                                </Grid>


                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12, px: sCell ? 0 : 4}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={8}
                    >

                        {pdfs.map((it, index) => (
                            <Grid container size={{xs: 12, sm: 6, md: 4}} sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Documentos item={it}/>
                            </Grid>
                        ))}

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Seccion_Documentos


const documentos = [
    {
        nombre: 'Documento Uno',
    },
    {
        nombre: 'Documento Dos',
    },
    {
        nombre: 'Documento Tres',
    },
    {
        nombre: 'Documento Cuatro',
    },
]